import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAddVideoMutation } from '../../features/videos/videosApi';

const AddVideo = () => {
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [addVideo, { isLoading, isError, isSuccess }] = useAddVideoMutation()

    const onSubmit = (data) => {

        addVideo(data)
    };
    useEffect(() => {
        if (isSuccess) {
            toast.success('successfully added')
            navigate('/admin/videos')
        }
        if (isError) {
            toast.error('something went wrong ')
        }

    }, [isSuccess, isError, navigate])
    return (
        <div className='flex justify-center'>
            <div className='w-1/2'>
                <form className='form-wrap' onSubmit={handleSubmit(onSubmit)}>
                    <label htmlFor="title">Title:</label>
                    <input className='login-input' placeholder='title' type="text" id="title" {...register("title", { required: true })} />

                    {errors.title && <span>This field is required</span>}

                    <label htmlFor="description">Description:</label>
                    <input placeholder='Description' type="text" className='login-input' id="description" {...register("description", { required: true })} />

                    <label htmlFor="url">URL:</label>
                    <input placeholder='https://www.youtube.com/embed/htSornje5FE' type="text" className='login-input' id="url" {...register("url", { required: true, pattern: /^(https:\/\/www\.youtube\.com\/embed\/|https:\/\/player\.vimeo\.com\/video\/)[^ "]+$/, })} />
                    {errors.url?.type === "pattern" && (
                        <p className='text-error'>Please enter a valid youtube Video URL</p>
                    )}
                    <label htmlFor="views">Views:</label>
                    <input placeholder='23.2k' type="text" className='login-input' id="views" {...register("views", { required: true })} />

                    <label htmlFor="duration">Duration:</label>
                    <input type="text" placeholder='2.26' className='login-input' id="duration" {...register("duration", { required: true })} />

                    <button disabled={isLoading} className='mt-5 py-2 px-5 rounded-md border border-blue-500' type="submit">Submit</button>
                </form>

            </div>
        </div>
    );
};

export default AddVideo;